module.exports = __webpack_public_path__ + "9e349b6632a81e6d9b6cd8f2206014f7.png";